import {PipeTransform, Pipe} from '@angular/core';
import {isString, isBlank} from '../facade/lang';
import {InvalidPipeArgumentException} from './invalid_pipe_argument_exception';
export class UpperCasePipe implements PipeTransform {
  transform(value: string): string {
    if (isBlank(value)) return value;
    if (!isString(value)) {
      throw new InvalidPipeArgumentException(UpperCasePipe, value);
    }
    return value.toUpperCase();
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{name: 'uppercase'}, ] },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
